import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import DefaultLayout from "./components/layouts/DefaultLayout";
import Home from "./components/pages/holdings/Home";
import Contact from "./components/pages/holdings/Contact";
import AboutUs from "./components/pages/holdings/AboutUs";
import OurNetworks from "./components/pages/holdings/OurNetworks";
import SolutionsLayout from "./components/layouts/SolutionsLayout";
import RealtyLayout from "./components/layouts/RealtyLayout";
import SolutionsHome from "./components/pages/solutions/Home";
import WhatWeDo from "./components/pages/solutions/WhatWeDo";
import WhatWeOffer from "./components/pages/solutions/WhatWeOffer";
import SolutionsContact from "./components/pages/solutions/Contact";
import RealtyHome from "./components/pages/realty/Home";
import Blog from "./components/pages/realty/Blog";
import About from "./components/pages/realty/About";
import Listings from "./components/pages/realty/Listings";
import RealtyContact from "./components/pages/realty/Contact";
import MergersAcquisitions from "./components/pages/holdings/ourexpertise/MergersAcquisitions";
import BusinessAdvisory from "./components/pages/holdings/ourexpertise/BusinessAdvisory";
import RealEstate from "./components/pages/holdings/ourexpertise/RealEstate";
import TaxConsulting from "./components/pages/holdings/ourexpertise/TaxConsulting";
import WhatsAppFloating from "./components/animation/WhatsAppFloating";
import { useRouteError } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import InstagramFloating from "./components/animation/InstagramFloating";
import NotFound from "./components/pages/NotFound";
import BlogView from "./components/pages/realty/BlogView.jsx";
import ListingView from "./components/pages/realty/listings/ListingView";
import BusinessSetUp from "./components/pages/solutions/BusinessSetUp";
import Careers from "./components/pages/careers/Careers.jsx";
import UserProfile from "./components/pages/profiles/UserProfile.jsx";



function App() {
  // ErrorBoundary component

  function ErrorBoundary() {
    const error = useRouteError();
    // const navigate = useNavigate();
    // React.useEffect(() => {
    //   navigate("/");
    // }, [navigate]);
    return (
      <div className="min-h-dvh relative flex flex-col items-center justify-center px-6 text-center overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 z-[-1] animate-gradient bg-[linear-gradient(270deg,#ff4242,#a1ff42,#42a1ff,#42d0ff,#a142ff)] bg-[length:400%_400%] opacity-20 blur-3xl"></div>

        <h1 className="text-4xl font-bold text-white drop-shadow-md">
          Something went wrong.
        </h1>
        <p className="mt-4 text-red-300 text-lg max-w-xl">
          ERROR:{" "}
          {error?.statusText || error?.message || "Unknown error occurred"}
        </p>

        <a
          href="/"
          className="px-5 py-2 rounded-lg mt-3 font-semibold bg-white text-black border border-black text-sm hover:opacity-80 transition duration-200 "
        >
          Back to Home
        </a>
      </div>
    );
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <DefaultLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { index: true, element: <Home /> },
        { path: "about-us", element: <AboutUs /> },
        { path: "contact", element: <Contact /> },
        { path: "careers", element: <Careers /> },
        { path: "mergers-and-Acquisitions", element: <MergersAcquisitions /> },
        { path: "business-advisory", element: <BusinessAdvisory /> },
        { path: "real-estate", element: <RealEstate /> },
        { path: "tax-consulting", element: <TaxConsulting /> },
        { path: "our-networks", element: <OurNetworks /> },
      ],
    },
    {
      path: "/solutions",
      element: <SolutionsLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { index: true, element: <SolutionsHome /> },
        { path: "what-we-do", element: <WhatWeDo /> },
        { path: "what-we-offer", element: <WhatWeOffer /> },
        { path: "business-set-up", element: <BusinessSetUp /> },
        { path: "careers", element: <Careers /> },
        { path: "contact", element: <SolutionsContact /> },
      ],
    },
    {
      path: "/realty",
      element: <RealtyLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { index: true, element: <RealtyHome /> },
        { path: "blog", element: <Blog /> },
        { path: "blog/:id", element: <BlogView /> },
        { path: "about-us", element: <About /> },
        { path: "listings", element: <Listings /> },
        { path: "careers", element: <Careers /> },
        { path: "listings/:id", element: <ListingView /> },
        { path: "contact", element: <RealtyContact /> },
      ],
    },
    // profile routes
    { path: "/:username", element: <UserProfile /> },
    // Top-level fallback if someone accesses a completely unknown route
    { path: "*", element: <NotFound /> },
  ], {
    future: {
      v7_startTransition: true,
    },
  });
  return (
    <div className="relative overflow-x-hidden">
      <RouterProvider router={router}></RouterProvider>
      <WhatsAppFloating />
      <InstagramFloating />
      {/* bg circle1 */}
      <div className="bg-gold/20 absolute top-1/3 -right-20 z-[-1] h-64 w-64 rounded-full opacity-80 blur-3xl select-none"></div>
      <div className="bg-gold/20 absolute top-1/4 -left-24 z-[-1] h-64 w-64 rounded-full opacity-80 blur-3xl select-none"></div>
      <div className="absolute bottom-[50rem] left-[0px] z-[-1] h-[150px] w-[300px] rotate-[0deg] transform rounded-full bg-gradient-to-tl from-slate-800 via-gold/50 to-zinc-400 blur-[150px]" />
      <div className="shaded-bg"></div>
    </div>
  );
}

export default App;
